<template>
  <div id="app">
    <div class="row no-gutters flex-column">
      <div class="col-auto">
        <kez-navbar/>
      </div>
      <div class="col row no-gutters">
        <div class="col-12 col-md-auto align-self-stretch sidebar-container">
          <kez-sidebar/>
        </div>
        <div class="col-12 col-md content align-self-stretch" v-bind:style="{padding:0}">
          <router-view/>
        </div>
      </div>
    </div>
    <alert-modal/>
    <loading-screen/>
  </div>
</template>

<script>
import KezNavbar from "./components/_kezBudget/KezNavbar";
import KezSidebar from "./components/_kezBudget/KezSidebar";
import AlertModal from "./components/alerts/AlertModal";
import LoadingScreen from "./components/app/LoadingScreen";

export default {
  components: {
    KezNavbar,
    KezSidebar,
    AlertModal,
    LoadingScreen
  },
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("init");
  }
};
</script>
<style lang="scss" scoped>
@import "src/styles/_includes.scss";
.flex-column {
  @include media-breakpoint-up(md) {
    height: 100vh;
  }
}
.content,
.sidebar-container {
  overflow: auto;
}
.content {
  > .container {
    padding-top: 5rem;
    padding-bottom: 1rem;
  }
}
</style>
